module.exports = __webpack_public_path__ + "media/images/signature-9f41bf46ff45e9c1730e963ab1b6b7d0.png";